var _g, _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 123,
    viewBox: "0 0 100 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1961_4473)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 17H70C72.6522 17 75.1957 17.7726 77.0711 19.1479C78.9464 20.5232 80 22.3884 80 24.3333V77.8667C80 83.7014 76.8393 89.2972 71.2132 93.423C65.5871 97.5488 57.9565 99.8667 50 99.8667C42.0435 99.8667 34.4129 97.5488 28.7868 93.423C23.1607 89.2972 20 83.7014 20 77.8667V24.3333C20 22.3884 21.0536 20.5232 22.9289 19.1479C24.8043 17.7726 27.3478 17 30 17Z",
    fill: "#181818"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 105L41 97.6667H59L50 105Z",
    fill: "#181818"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6138 48.582C38.1858 48.582 37.7753 48.7521 37.4727 49.0547C37.17 49.3573 37 49.7678 37 50.1958V66.2078C37 66.6358 37.17 67.0462 37.4727 67.3489C37.7753 67.6515 38.1858 67.8215 38.6138 67.8215H39.3952V66.4994H38.5619C38.4842 66.4992 38.4097 66.4682 38.3547 66.4132C38.2997 66.3582 38.2687 66.2837 38.2684 66.2059V50.1977C38.2687 50.1199 38.2997 50.0454 38.3547 49.9904C38.4097 49.9354 38.4842 49.9044 38.5619 49.9042H40.7285V49.4199C40.7295 49.1387 40.7571 48.8581 40.8109 48.582H38.6138ZM61.5651 48.582H59.3865C59.4169 48.7632 59.433 48.9465 59.4347 49.1301V49.9042H61.6188C61.6966 49.9042 61.7713 49.9351 61.8263 49.9901C61.8814 50.0452 61.9123 50.1198 61.9123 50.1977V66.2068C61.9123 66.2454 61.9047 66.2835 61.8899 66.3191C61.8752 66.3548 61.8536 66.3871 61.8263 66.4144C61.7991 66.4416 61.7667 66.4632 61.7311 66.478C61.6955 66.4927 61.6573 66.5003 61.6188 66.5003H60.7651V67.8225H61.5651C61.9932 67.8225 62.4037 67.6525 62.7065 67.3499C63.0093 67.0472 63.1796 66.6368 63.1798 66.2087V50.1958C63.1796 49.7679 63.0094 49.3576 62.7069 49.055C62.4043 48.7524 61.994 48.5823 61.566 48.582H61.5651Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7301 69.9955C57.7145 69.9978 57.6986 69.9978 57.6829 69.9955H54.41C54.3651 70.0019 54.3195 69.9901 54.2832 69.9629C54.2469 69.9356 54.2229 69.8951 54.2165 69.8502C54.2142 69.8345 54.2142 69.8186 54.2165 69.803V49.8996H51.911V66.2763V69.8826C51.911 69.9576 51.8472 69.9946 51.7185 69.9946H48.4464C48.3177 69.9946 48.2529 69.9576 48.2529 69.8826V49.8996H45.9466V69.8057C45.9498 69.828 45.9484 69.8507 45.9427 69.8724C45.9371 69.8942 45.9272 69.9146 45.9136 69.9325C45.9 69.9504 45.883 69.9654 45.8635 69.9767C45.8441 69.988 45.8226 69.9954 45.8003 69.9983C45.7847 70.0006 45.7688 70.0006 45.7531 69.9983H42.482C42.4371 70.0047 42.3915 69.9929 42.3552 69.9657C42.319 69.9384 42.2949 69.8979 42.2885 69.853C42.2866 69.8373 42.2866 69.8214 42.2885 69.8057V49.5672C42.2906 49.2344 42.3361 48.9032 42.4237 48.5821C42.5769 47.8498 42.9792 47.1933 43.5621 46.7245C44.1451 46.2557 44.8727 46.0035 45.6207 46.011H54.3313C55.1203 45.946 55.9059 46.1713 56.5406 46.6445C57.1753 47.1178 57.6154 47.8064 57.7783 48.5812C57.8387 48.8236 57.8713 49.0721 57.8755 49.3219V69.8057C57.881 69.8501 57.8689 69.8949 57.8417 69.9304C57.8145 69.9659 57.7744 69.9893 57.7301 69.9955Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1961_4473",
    x: 0,
    y: 0,
    width: 100,
    height: 122.867,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.051 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1961_4473"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1961_4473",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMm);
export default __webpack_public_path__ + "static/media/mm.64a6240619cabadd34fa2897ecedce74.svg";
export { ForwardRef as ReactComponent };